import React from "react";
import { Button } from "../../components/ui";

const FilterList = ({
  active,
  categoryId,
  onChange,
  includeStatusFilter = false,
}) => {
  let filters = [
    { value: "brand_id", label: "Brand" },
    { value: "model_id", label: "Model" },
    { value: "price", label: "Price" },
  ];

  // Add status filter for manage listings
  if (includeStatusFilter) {
    filters.unshift({ value: "status", label: "Status" });
  }

  if (categoryId === 9) {
    filters = filters.concat([
      { value: "condition", label: "Condition" },
      { value: "location", label: "Location" },
    ]);
  }

  if (categoryId === 9) {
    // watches
    filters = filters.concat([
      { value: "case_material", label: "Case material" },
      { value: "case_diameter", label: "Case size" },
      { value: "dial_color", label: "Dial color" },
    ]);
  }

  return (
    <div className="pivots flex-shrink-1">
      <nav aria-label="Filters" className="d-flex flex-column">
        {filters.map((f) => (
          <Button
            key={f.value}
            variant="ghost"
            fullWidth
            active={f.value === active}
            aria-current={f.value === active ? "true" : undefined}
            data-btn="filters-open"
            onClick={() => onChange(f.value)}
          >
            {f.label}
          </Button>
        ))}
      </nav>
    </div>
  );
};

export default FilterList;
